<template>
  <reporting-api page-name="pod" :countdown="true">
    <template slot-scope="data">
      <b-row>
        <b-col sm="6" md="3" class="stats">
          <label>Health reports</label>
          <div class="stat-value"><i class="fas fa-medkit"></i> {{ data.page.stats[0].ping_count | commas }}</div>
        </b-col>
        <b-col sm="6" md="3" class="stats">
          <label>Health reports in last 5-days</label>
          <div class="stat-value"><i class="fas fa-medkit"></i> {{ data.page.stats[0].ping_count_5_days | commas }}</div>
        </b-col>
        <b-col sm="6" md="3" class="stats">
          <label>Stores with errors in last 24-hours</label>
          <div class="stat-value">
            <i class="fas fa-exclamation-triangle text-danger"></i> 
            {{ data.page.stats[0].error_store_count_24_hours | commas }}
          </div>
        </b-col>
        <b-col sm="6" md="3" class="stats">
          <label>Stores with errors in last 5-days</label>
          <div class="stat-value">
            <i class="fas fa-exclamation-triangle text-danger"></i> 
            {{ data.page.stats[0].error_store_count_5_days | commas }}
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col v-if="data.page.storesWithErrors.length > 0">
          <b-card variant="white" title="Recent stores with issues">
            <b-table :items="data.page.storesWithErrors" :fields="['store','num_of_errors']">
              <template slot="store" slot-scope="data">
                <router-link :to="`/customers/pod/servers/${data.item.location}`">{{ data.value }}</router-link>
              </template>
              <template slot="HEAD_num_of_errors" slot-scope="data"><div class="text-right"># of Errors</div></template>
              <template slot="num_of_errors" slot-scope="data">
                <div class="text-right">{{ data.value | commas }}</div>
              </template>
            </b-table>
          </b-card>
        </b-col>
        <b-col v-if="data.page.potentiallyOffline.length > 0">
          <b-card variant="white" title="Potentially offline">
            <b-table :items="data.page.potentiallyOffline" :fields="['store','last_heard_from']">
              <template slot="store" slot-scope="data">
                <router-link :to="`/customers/pod/servers/${data.item.location}`">{{ data.value }}</router-link>
              </template>
              <template slot="last_heard_from" slot-scope="data">
                {{ data.value.value | moment('from', 'now') }}
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card variant="white" title="Most recent errors">
            <b-table :items="data.page.recentErrors" :fields="['location', 'raised_at_utc', 'report_type', 'message']">
              <template slot="HEAD_raised_at_utc" slot-scope="data">When</template>
              <template slot="location" slot-scope="data">
                <router-link :to="`/customers/pod/servers/${data.item.link_location}`">{{ data.value }}</router-link>
              </template>
              <template slot="raised_at_utc" slot-scope="data">
                {{ data.value.value | moment('from', 'now') }}
              </template>
              <template slot="message" slot-scope="data">
                {{ smartMessage(data.value) }}
              </template>
              <template slot="report_type" slot-scope="data">
                {{ translateReportType(data.value) }}
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </template>
  </reporting-api>
</template>

<script>
import ReportingApi from '@/components/ReportingApi.vue'
import * as moment from 'moment';

export default {
  components: { ReportingApi },
  methods: {
    translateReportType(reportType) {
      switch (reportType) {
        case 'P':
          return 'Health report';
        case 'C':
          return 'Camera issue';
        case 'S':
          return 'Service issue';
        default:
          return 'Error';
      }
    },
    smartMessage(message) {
      const match = message.match(/^Camera folder was inactive for ([0-9\.,]+)\s?secs$/);
      if (match != null) {
        const seconds = Math.ceil(parseFloat(match[1]));
        const human = moment.duration(seconds, 'seconds').humanize();
        return `Inactive camera folder, no new content for ${human}`;
      }
      return message;
    }
  }
}
</script>
